// extracted by mini-css-extract-plugin
export default {"icon":"Schwerpunkte_icon__Ma1Kh","Kategorie":"Schwerpunkte_Kategorie__5m-6x","wrapper":"Schwerpunkte_wrapper__EWGMj","coloredHeading":"Schwerpunkte_coloredHeading__eKRAG"};